export const uhcThemeOverride = {
  theme: {
    colors: {
      infoFooterBackground: '#f4f6fa',
      uhcPrimary1: '#002677',
      lightGray: '#D0D0D0',
      cardBorder: '$gray3',
      neutralGray: '$gray7',
      neutralGray2: '#F2F2F2',
      neutralGray5: '#6E7072',
      descriptionBlack: '#19191A',
      neutralGray7: '$gray8',
      neutralGray4: '$gray4',
      starBorder: '#D2800F',
      bgHeaderColor: '#FBFCFE',
      icColor: '$gray8',
      tcolor: '$interactive1',
      bgProviderDetailsColor: '$bgHeaderColor',
      tabsContainerBackgroundColor: '#FAFAFA',
      tabButtonBackgroundColor: '#FAFAFA',
      tabSelectionTextColor: '$gray8',
      mapViewContainerBgColor: '$white',
      whereToGetHelpCardBg1: '$info2',
      whereToGetHelpCardBg2: '#FCF6F1',
      whereToGetHelpCardBg3: '$tint2',
      tabNotSelectedTextColor: '$interactive1',
      snackCardAvatarBackgroundColor: '#EEF8FB',
      milesTextColor: '$accent1',
      headerCardWrapperBorderColor: '$cardBorder',
      virtualVisitIconColor: '$primary1',
      searchBorderColor: '$lightGray',
      recentVisitCardSliderBg: '$white',
      memberInitialsBgColor: '#pastel1',
      memberInitialsTextColor: '$primary1',
      pageBodyBgColor: '$white',
      providerDetailsDrawerHeaderBgColor: '$primary1',
      providerDetailsDrawerHeaderLoadingBgColor: '$primary1',
      providerDetailsDrawerHeaderTextColor: '$primary2',
      providerDetailsDrawerHeaderHighlightColor: '$primary2',
      providerDetailsDrawerHeaderInNetworkStatusIconColor: '$primary2',
      providerDetailsDrawerHeaderInNetworkStatusLabelColor: '$primary2',
      providerDetailsDrawerLocationsDropdownOptionColor: '$primary1',
      searchIconColor: '$interactive1',
      errorTextColor: '#D14600',
      notificationColor: '$primary1',
      notificationInteractiveColor: '$interactive1',
      refreshIconColor: '$interactive2',
      subTextcolor: '$interactive1',
      orText: '#424242',
      greyBorderColor: '#CBCCCD',
      black30: '#4B4D4F',
      lightGrey: '#E5E5E6',
      lightGrey2: '#eff0f0',
      blue: '#196ECF',
      lightBlue: '#E5F8FB',
      darkBlue: '#002677',
      gray8: '#323333',
    },
    fontSizes: {
      extraSmallText: '12.64px',
      smallText: '14.24px',
      mediumText: '20.25px',
      largeText: '25.63px',
      dateInfoText: '12.64px',
      providerDetailsDrawerBHFooterTimeStampText: '$md',
      providerDetailsDrawerBHFooterDateText: '$md',
    },
    fontWeights: {
      memeberInitialsFW: '500',
      providerDetailsDrawerHeaderInNetworkFW: '$medium',
      providerDetailsDrawerBHFooterDateFW: '$medium',
    },
    lineHeights: {
      lg: '24px',
      xl: '32px',
      md: '20px',
      sm: '16px',
    },
    space: {
      wrapperPadding: '24px 0',
      headerWrapperPadding: '24px 0',
      tabButtonsPadding: '5px 0 5px 0',
      recentSearchBottomGap: '8px',
      recentActivityTopPadding: '24px',
      popoverContainerTop: '3px',
    },
    borderWidths: {
      recentActivityBorder: '1px',
    },
    sizes: {
      iconBrandSize: '72px',
      dataCardForMapIconSize: '49px',
      dataCardIconSize: 49,
      snackCardIconSize: 72,
      snackCardIconMobileSize: 60,
      detailsIconSize: 84,
      compareAndShareIconSize: 64,
      recentVisitSnackcardIconSize: 56,
      detailsWidgetHeaderIconSize: 84,
      choosePCPLocationIconSize: 42,
      confirmPCPLocationIconSize: 42,
      choosePCPSuccessIconSize: 45,
    },
     overflow:{
      popoverContentOverflow:'auto'
    },
    maxHeight:{
      popoverContentHeight:'auto'
    }
  },
};
